export const createSystemMutation = (
    name: string, abbreviation: string, type: string, logoUrl: string | null = null
) => {
    return `mutation {
        createSystem(
            name: "${name}",
            abbreviation: "${abbreviation}",
            type: "${type}"${logoUrl ? `,\n            logoUrl: "${logoUrl}"` : ''}
        ) {
            system {
                id
                name
                abbreviation
                type
                logoUrl
            }
        }
    }`
}
